/* House of Saya — money format shim
 * Converts "Rs. 999.00" / "Rs. 999.00" / "Rs 999" → "₹999"
 * Until Shopify Admin → Settings → General → Currency display is updated.
 * Runs on DOM ready and again on cart/section updates.
 */
(function () {
  const RE = /Rs\.?\s*([\d,]+)(?:\.\d+)?/g;

  function fix(node) {
    if (!node) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) =>
        RE.test(n.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT,
    });
    const targets = [];
    let cur;
    while ((cur = walker.nextNode())) targets.push(cur);
    for (const t of targets) {
      t.nodeValue = t.nodeValue.replace(RE, "₹$1");
    }
  }

  function run() { fix(document.body); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  // Re-run when Shopify section/cart re-renders
  document.addEventListener("shopify:section:load", run);
  document.addEventListener("cart:updated", run);
  document.addEventListener("cart:refresh", run);

  // Catch dynamic price updates (variant switcher etc.)
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1) fix(n);
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
